module.exports = {
  content: ["./src/*.{html,js}"],
  presets: [
    require('@turing-quest/tailwindcss-preset'),
  ],
}
